define(['jquery',
        'core/urls',
        'core/chargebee-modals',
        'bootstrap-slider',
        'bootstrap-toggle'],
    function($, urls, chargebee_modals) {

        return {
            init: function() {

                var alertSubscriptionErrors = $('#alert-subscription-danger');
                var toggleSubscriptionPeriod = $('#toggle-subscription-period');
                var priceProfessional = $('#price-professional');
                var priceProfessionalAnnual = $('#price-professional-annual');

                $('.slider').slider();
                recalculatePrice();
                $('.slider').on('change', recalculatePrice);
                toggleSubscriptionPeriod.on('change', recalculatePrice);

                $('#toggle-subscription-monthly').click(function() {
                    toggleSubscriptionPeriod.prop('checked', false).change();
                });
                $('#toggle-subscription-yearly').click(function() {
                    toggleSubscriptionPeriod.prop('checked', true).change();
                });
                function recalculatePrice() {
                    var tier = $('#slider-subscription-tier').data('slider').getValue();
                    var yearly = toggleSubscriptionPeriod.prop('checked') ? 1 : 0;

                    $('.slider-tick-label').removeClass('active');
                    // set the current slider label class to active
                    $('.slider-tick-label:eq(' + tier + ')').addClass('active');

                    $('.toggle-subscription-label').removeClass('active');
                    // set the current monthly/yearly label class to active,
                    $('.toggle-subscription-label:eq(' + yearly + ')').addClass('active');

                    if (tier === 8) {
                        $('#price-calculator').hide();
                        $('#price-contact-us').show();
                    } else {
                        let slider = document.querySelector("#slider-subscription-tier");
                        let monthlyPrices = JSON.parse(slider.dataset.pricesMonthly);
                        let annualPrices = JSON.parse(slider.dataset.pricesYearly);

                        if (yearly === 0) {
                            priceProfessional.text(monthlyPrices[tier]);
                            priceProfessionalAnnual.html('pay annually and get 2 months free');

                        } else {
                            priceProfessional.text(annualPrices[tier] / 12);
                            priceProfessionalAnnual.html('($' + (annualPrices[tier]).toLocaleString('en-US') + '/yr.) paid annually');
                        }
                        $('#price-contact-us').hide();
                        $('#price-calculator').show();
                    }
                }

                function generateSubscribeButtonCallback() {
                    return function(e){
                        e.preventDefault();

                        alertSubscriptionErrors.hide();
                        var clickedButton = $(this);

                        // disable button and change text
                        clickedButton.button('loading');
                        // disable price range input slider
                        $('#slider-subscription-tier').slider('disable');
                        // disable monthly/yearly switch
                        toggleSubscriptionPeriod.bootstrapToggle('disable');
                        var level = 'PRO';
                        // get tier level from slider input
                        var tier = parseInt($('#slider-subscription-tier').val()) + 1;
                        // identify billing period
                        var yearly = toggleSubscriptionPeriod.prop('checked') ? 'YR' : 'MO';
                        // set the submission plan name for chargebee
                        var planId = 'SB-' + tier + '-' + yearly + '-v5';

                        // show the Chargebee Hosted Page iFrame PopUp/Modal
                        chargebee_modals.openCheckoutModal(planId, onCheckoutSuccess, onCheckoutFailure, onCheckoutCancel);
                    };
                }

                function onCheckoutSuccess() {
                    $('#purchase-form-area').fadeOut();
                    $('#subscriptions-cc-note').hide();
                    $('.sb-mainnav-item-subscribe').hide();
                    $('#alert-subscription-success').slideDown();
                }

                function onCheckoutFailure() {
                    onCheckoutCancel();
                    $('#alert-subscription-danger').slideDown();
                }

                function onCheckoutCancel() {
                    $('#pricing-box-professional').fadeIn();
                    $('#slider-subscription-tier').slider('enable');
                    toggleSubscriptionPeriod.bootstrapToggle('enable');
                    $('#button-subscribe-professional').button('reset');
                }
                var subscribeProfessionalCallback = generateSubscribeButtonCallback();
                $('#button-subscribe-professional').click(subscribeProfessionalCallback);
            }
        };
    }
);
